import * as React from 'react'

function Upload(props) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill="currentColor" d="M9.99999 12.501C10.46 12.501 10.833 12.128 10.833 11.668V5.001L12.833 6.5C13.202 6.777 13.724 6.702 14 6.333C14.277 5.965 14.202 5.443 13.833 5.167L10.5 2.667C10.352 2.556 10.176 2.5 9.99999 2.5C9.83199 2.5 9.66499 2.55 9.51999 2.652L6.18799 4.997C5.81099 5.262 5.71999 5.782 5.98499 6.157C6.24999 6.534 6.76899 6.625 7.14499 6.36L9.16899 4.935L9.16699 5.001V11.668C9.16699 12.128 9.53899 12.501 9.99999 12.501Z" />
      <path fill="currentColor" d="M15.833 13.333C16.292 13.333 16.667 13.708 16.667 14.167V15.833C16.667 16.256 16.347 16.608 15.937 16.66L15.833 16.667H4.16699C3.70799 16.667 3.33299 16.292 3.33299 15.833V14.167C3.33299 13.708 3.70799 13.333 4.16699 13.333C4.62499 13.333 4.99999 13.708 4.99999 14.167V15H15V14.167C15 13.708 15.375 13.333 15.833 13.333Z" />
    </svg>
  )
}

export default Upload
